'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubtractIcon = function SubtractIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M27.002,15.021 L5,15 L5,15 C4.447,15 4,15.447 4,15.999 C3.999,16.551 4.446,16.999 4.998,17 L27,17 C27.553,17 28,16.574 28,16.023 C28.001,15.471 27.554,15.023 27.002,15.021 L27.002,15.021 Z' })
  );
};

SubtractIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = SubtractIcon;